import iconChevronDown from 'Assets/Icons/AdminDashboard/mn9vwcis-68oqs55.png' // Reusing existing icon or placeholder

const StationPerformance = () => {
  return (
    <div className='chartCard chartCard-2'>
      <div className='chartHeader'>
        <div>
          <h4 className='chartTitle'>Station Performance</h4>
          <div className='chart-tagline'>Top performing BoostXpress partner stations by volume</div>
        </div>
        <div className='chartFilter'>
          <button className='btn btn-view-station'>View All Station</button>
          <img src={iconChevronDown} alt='Filter' className='filterIcon' />
        </div>
      </div>
      <div className='row'>
        <div className='col-6'>
          <div className='chartContent-2'>
            <div className='stat-label'>Active stations</div>
            <div className='stat-value'>1,047</div>
          </div>
        </div>
        <div className='col-6'>
          <div className='chartContent-2'>
            <div className='stat-label'>Today&apos;s total vol</div>
            <div className='stat-value'>₦63.2M</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StationPerformance
